<h2 mat-dialog-title>{{data.dialogTitle}}</h2>
<mat-dialog-content style="margin-top: 10px;">{{data.dialogDesc}}</mat-dialog-content>
<ion-row >
  <ion-col style="text-align: end;">
  <button  mat-dialog-close>Close</button>
  </ion-col>
</ion-row>